// src/pages/UserManagement/modals/DeleteUserDialog.tsx
// Delete confirmation dialog using Velzon's DeleteModal component

import React from 'react';
import DeleteModal from 'Components/Common/DeleteModal';

interface DeleteUserDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  userName: string;
}

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  isOpen,
  onClose,
  onDelete,
  userName,
}) => {
  return (
    <DeleteModal
      show={isOpen}
      onCloseClick={onClose}
      onDeleteClick={onDelete}
      recordName={userName}
    />
  );
};

export default DeleteUserDialog;
